import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, SplitText);
const isMobileFirstLoad = window.innerWidth < 768;

if (!isMobileFirstLoad) {

    const titleConfig = new SplitText(
        '.mksun-config .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words'
        }
    );

    const linesConfig = new SplitText('.mksun-config .timeline-text-reveal--lines', {
        type: 'lines',
        linesClass: 'line'
    });

    const tlConfig = gsap.timeline({
        scrollTrigger: {
            trigger: '.mksun-config'
        }
    });

    tlConfig.set('.mksun-config', {
        backgroundSize: 'auto 100%, cover',
    });
    tlConfig.from('.mksun-config', {
        width: 0,
        duration: .5,
        clearProps: "all"
    })

    tlConfig.from('.mksun-config', {
        backgroundSize: '50%, cover',
        duration: .5,
        clearProps: "all"
    }, '>')

    tlConfig.from(titleConfig.words, {
        y: '100%',
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
        stagger: 0.1
    });

    tlConfig.from(
        linesConfig.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlConfig.from('.mksun-config .mksun-config__head__input-zip > *', {
        y: '100%',
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
        stagger: 0.1
    }, '<')
}